import NeighborhoodContainerAdmin from './Neighborhood/Container/admin';
import ProvinceContainer          from './Province/Container'          ;
import CityContainer              from './City/Container'              ;
import AreaContainerAdmin         from './Area/Container/admin'        ;

import AreaContainerCompany         from './Area/Container/company'        ;
import NeighborhoodContainerCompany from './Neighborhood/Container/company';

type Props = {
  Admin: {
    NeighborhoodContainer: typeof NeighborhoodContainerAdmin;
    ProvinceContainer    : typeof ProvinceContainer         ;
    CityContainer        : typeof CityContainer             ;
    AreaContainer        : typeof AreaContainerAdmin        ;
  },
  Company: {
    NeighborhoodContainer: typeof NeighborhoodContainerCompany;
    AreaContainer        : typeof AreaContainerCompany        ;
  }
}

const Screens: Props = {
  Admin: {
    NeighborhoodContainer: NeighborhoodContainerAdmin,
    ProvinceContainer    ,
    CityContainer        ,
    AreaContainer        : AreaContainerAdmin        ,
  },
  Company: {
    NeighborhoodContainer: NeighborhoodContainerCompany,
    AreaContainer        : AreaContainerCompany        ,
  }
};

export default Screens;
